export enum AppPermissions {
    // Identity & Access Management (IAM)
    READ_USER = 'READ_USER',
    CREATE_USER = 'CREATE_USER',
    UPDATE_USER = 'UPDATE_USER',
    DELETE_USER = 'DELETE_USER',
    READ_ORGANIZATION = 'READ_ORGANIZATION',
    MANAGE_ORGANIZATION = 'MANAGE_ORGANIZATION',

    // Core Taxonomy & Integrations
    READ_BRAND = 'READ_BRAND',
    MANAGE_BRAND = 'MANAGE_BRAND',
    READ_TAXONOMY = 'READ_TAXONOMY',
    MANAGE_TAXONOMY = 'MANAGE_TAXONOMY',
    READ_INTEGRATIONS = 'READ_INTEGRATIONS',
    MANAGE_INTEGRATIONS = 'MANAGE_INTEGRATIONS',

    // Market Data & Catalog
    READ_PRODUCTS = 'READ_PRODUCTS',
    UPDATE_PRODUCTS = 'UPDATE_PRODUCTS',
    DELETE_PRODUCTS = 'DELETE_PRODUCTS',
    VIEW_ANALYTICS = 'VIEW_ANALYTICS',

    // Executions & Workflows
    READ_EXECUTIONS = 'READ_EXECUTIONS',
    START_EXECUTION = 'START_EXECUTION',
    STOP_EXECUTION = 'STOP_EXECUTION',
    MANAGE_SCHEDULERS = 'MANAGE_SCHEDULERS',
    READ_TASKS = 'READ_TASKS',

    // Extended Sidebar Permissions
    READ_ROLES = 'READ_ROLES',
    CREATE_ROLE = 'CREATE_ROLE',
    UPDATE_ROLE = 'UPDATE_ROLE',
    DELETE_ROLE = 'DELETE_ROLE',
    READ_CATEGORIES = 'READ_CATEGORIES',
    CREATE_CATEGORY = 'CREATE_CATEGORY',
    UPDATE_CATEGORY = 'UPDATE_CATEGORY',
    DELETE_CATEGORY = 'DELETE_CATEGORY',

    READ_PLATFORMS = 'READ_PLATFORMS',
    CREATE_PLATFORM = 'CREATE_PLATFORM',
    UPDATE_PLATFORM = 'UPDATE_PLATFORM',
    DELETE_PLATFORM = 'DELETE_PLATFORM',

    READ_API_PROVIDERS = 'READ_API_PROVIDERS',
    CREATE_API_PROVIDER = 'CREATE_API_PROVIDER',
    UPDATE_API_PROVIDER = 'UPDATE_API_PROVIDER',
    DELETE_API_PROVIDER = 'DELETE_API_PROVIDER',

    READ_LLM_PROVIDERS = 'READ_LLM_PROVIDERS',
    CREATE_LLM_PROVIDER = 'CREATE_LLM_PROVIDER',
    UPDATE_LLM_PROVIDER = 'UPDATE_LLM_PROVIDER',
    DELETE_LLM_PROVIDER = 'DELETE_LLM_PROVIDER',

    READ_JSON_TEMPLATES = 'READ_JSON_TEMPLATES',
    CREATE_JSON_TEMPLATE = 'CREATE_JSON_TEMPLATE',
    UPDATE_JSON_TEMPLATE = 'UPDATE_JSON_TEMPLATE',
    DELETE_JSON_TEMPLATE = 'DELETE_JSON_TEMPLATE',
    READ_JSON_GENERATION = 'READ_JSON_GENERATION',
    READ_MARKET_DATA_DUMP = 'READ_MARKET_DATA_DUMP',
    READ_GEN_INSIGHTS = 'READ_GEN_INSIGHTS',
    READ_EXPERIANCE_DASHBOARD = 'READ_EXPERIANCE_DASHBOARD',
    READ_ACTION_DASHBOARD = 'READ_ACTION_DASHBOARD',
    READ_CAMPAIGN_SETUP = 'READ_CAMPAIGN_SETUP',
    READ_CAMPAIGN = 'READ_CAMPAIGN',
    READ_MEDIA_ACTION_CENTER = 'READ_MEDIA_ACTION_CENTER',
    READ_RISK_CENTER = 'READ_RISK_CENTER',
    READ_GROWTH_LEVER = 'READ_GROWTH_LEVER',
    READ_CRO_BARRIERS = 'READ_CRO_BARRIERS',
    READ_PDP_INSIGHTS = 'READ_PDP_INSIGHTS',
    READ_PLP_INSIGHTS = 'READ_PLP_INSIGHTS',
    READ_REVIEWS_INSIGHTS = 'READ_REVIEWS_INSIGHTS',
    READ_INCENTIVE_INSIGHTS = 'READ_INCENTIVE_INSIGHTS',
    READ_GAP_LANDSCAPES = 'READ_GAP_LANDSCAPES',
    READ_PLATFORM_AUDIT = 'READ_PLATFORM_AUDIT',
    READ_PRODUCT_CATALOG = 'READ_PRODUCT_CATALOG',
    READ_SCHEDULERS = 'READ_SCHEDULERS',
    CREATE_SCHEDULER = 'CREATE_SCHEDULER',
    UPDATE_SCHEDULER = 'UPDATE_SCHEDULER',
    DELETE_SCHEDULER = 'DELETE_SCHEDULER',
    READ_AUDIENCE_AUDIT = 'READ_AUDIENCE_AUDIT',
    MANAGE_ACTION_PLANS = 'MANAGE_ACTION_PLANS',
    GENERATE_CONTENT = 'GENERATE_CONTENT',

    // Team & Action Management
    READ_TEAM_MEMBER = 'READ_TEAM_MEMBER',
    CREATE_TEAM_MEMBER = 'CREATE_TEAM_MEMBER',
    UPDATE_TEAM_MEMBER = 'UPDATE_TEAM_MEMBER',
    DELETE_TEAM_MEMBER = 'DELETE_TEAM_MEMBER',
    MANAGE_METRIC_SNAPSHOTS = 'MANAGE_METRIC_SNAPSHOTS',
}
